/**
 * Shared Privacy Policy content.
 *
 * Source of truth for the privacy policy body, rendered by
 * PrivacyPolicyPage. Section order matches GDPR/LGPD disclosure
 * convention (controller -> categories -> purposes -> basis -> rights).
 */

import { useTranslation } from '../../hooks/useTranslation';

const PRIVACY_SECTIONS = [
  'intro',
  'controller',
  'dataCollected',
  'purposes',
  'legalBasis',
  'aiProcessing',
  'subprocessors',
  'cookies',
  'retention',
  'transfers',
  'rights',
  'children',
  'desktop',
  'security',
  'changes',
  'contact',
] as const;

export function PrivacyContent() {
  const { t } = useTranslation();

  return (
    <>
      {PRIVACY_SECTIONS.map((key) => (
        <section key={key}>
          <h3 className="section-heading-purple">{t(`privacy.sections.${key}.title`)}</h3>
          <p className="text-sm text-white/70 leading-relaxed">
            {t(`privacy.sections.${key}.content`)}
          </p>
        </section>
      ))}
    </>
  );
}
